<!--
* @Name：收货单状态变更申请审批基本页面
* @Author: 陈名刚
* @Date: 2024-05-13
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="model.orderCode"></hi-cell>
    <hi-cell title="采购组织：" :value="model.purorgName"></hi-cell>
    <hi-cell title="变更方式：" :value="changeStatus"></hi-cell>
    <hi-cell title="申请人：" :value="`${model.applyName || ''}[${model.applyId || ''}]`"></hi-cell>
    <hi-cell title="申请时间：" :value="model.applyTime"></hi-cell>
    <hi-cell title="原因选择：" :value="changeReason"></hi-cell>
    <hi-cell title="变更说明：" :value="model.changeDescription"></hi-cell>
  </div>
</template>

<script>
import { dictFilter } from '/src/filters/index.js'

export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 变更方式
    changeStatus() {
      return dictFilter(this.model.changeStatus, this.$store.getters.dicts.change_status_type)
    },
    // 变更原因
    changeReason() {
      const dict =
        this.model.changeStatus === '0'
          ? this.$store.getters.dicts.suspend_reason
          : this.$store.getters.dicts.unsuspend_reason
      return dictFilter(this.model.changeReason, dict)
    }
  }
}
</script>
